<div class="wrap">
  <mat-card class="card-light" appearance="outlined">
    <div class="top">
      <div class="badge">
        <mat-icon class="lock">lock</mat-icon>
      </div>
      <div class="pulse"></div>
    </div>

    <h1 class="title">Sin acceso</h1>
    <p class="subtitle">
      Tu usuario inició sesión, pero no tiene permisos para entrar aquí.
    </p>

    <div class="info">
      <span
        >Pide al administrador que te asigne accesos a módulos/acciones.</span
      >
    </div>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="authService.logout()">
        <mat-icon>logout</mat-icon>
        Ir a login
      </button>
    </div>
  </mat-card>
</div>
